import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const SecurityAwareness: React.FC = () => {
  const sections = [
    {
      title: 'Security Awareness & Phishing Training',
      content: 'Our security awareness programs educate employees about cybersecurity threats and best practices, creating a human firewall to protect your organization. We provide comprehensive training programs, simulated phishing campaigns, and ongoing awareness initiatives.',
      benefits: [
        'Interactive security awareness training',
        'Simulated phishing campaigns and testing',
        'Role-based training customization',
        'Progress tracking and reporting',
        'Ongoing reinforcement and updates'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Security Awareness & Phishing"
      subtitle="Comprehensive security awareness training and phishing simulation programs to build a security-conscious workforce."
      sections={sections}
    />
  );
};

export default SecurityAwareness;

